import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { NAV_LINKS, SERVICES, PRODUCTS } from "@/lib/content";

const Column = ({ title, children }) => (
  <div>
    <h3 className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-kryvo-green">{title}</h3>
    <ul className="flex flex-col gap-2.5">{children}</ul>
  </div>
);

const FootLink = ({ to, children, testId }) => (
  <li>
    <Link to={to} data-testid={testId} className="text-sm text-kryvo-sub transition-colors hover:text-kryvo-green">
      {children}
    </Link>
  </li>
);

const Footer = () => (
  <footer className="border-t border-kryvo-line bg-kryvo-mist" data-testid="main-footer">
    <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-5">
      <div className="lg:col-span-2">
        <Link to="/" aria-label="Kryvo Technologies — home" data-testid="footer-logo-link">
          <Logo />
        </Link>
        <p className="mt-5 max-w-xs font-display text-lg font-medium text-kryvo-ink">
          Smart Technology for Growing Businesses.
        </p>
        <p className="mt-3 max-w-sm text-sm leading-relaxed text-kryvo-sub">
          Kryvo Technologies designs and builds modern digital products — and its own SaaS products,
          Kryvo CRM and Kryvo Engage.
        </p>
      </div>

      <Column title="Navigation">
        {NAV_LINKS.map((l) => (
          <FootLink key={l.to} to={l.to} testId={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
            {l.label}
          </FootLink>
        ))}
      </Column>

      <Column title="Services">
        {SERVICES.map((s) => (
          <FootLink key={s.slug} to={`/services/${s.slug}`} testId={`footer-service-${s.slug}`}>
            {s.name}
          </FootLink>
        ))}
      </Column>

      <Column title="Products">
        {PRODUCTS.map((p) => (
          <FootLink key={p.slug} to={`/products/${p.slug}`} testId={`footer-product-${p.slug}`}>
            {p.name}
          </FootLink>
        ))}
      </Column>
    </div>

    <div className="border-t border-kryvo-line">
      <div className="container-x flex flex-col items-center justify-between gap-4 py-6 sm:flex-row">
        <p className="text-xs text-kryvo-sub/80">© {new Date().getFullYear()} Kryvo Technologies. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <Link to="/privacy" data-testid="footer-privacy-link" className="text-xs text-kryvo-sub/80 transition-colors hover:text-kryvo-green">
            Privacy Policy
          </Link>
          <Link to="/terms" data-testid="footer-terms-link" className="text-xs text-kryvo-sub/80 transition-colors hover:text-kryvo-green">
            Terms of Service
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
